export default "__VITE_ASSET__BaTRTvhi__"